import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { AdminSidebar } from './AdminSidebar';
import { useAuth } from '../../lib/AuthContext';
export function AdminLayout() {
  const {
    isAdminLoggedIn
  } = useAuth();
  if (!isAdminLoggedIn) {
    return <Navigate to="/admin" replace data-id="element-53" />;
  }
  return <div className="min-h-screen w-full bg-[#0D0D0D]" data-id="element-54">
      <AdminSidebar data-id="element-55" />
      <main className="lg:ml-[240px] min-h-screen" data-id="element-56">
        <div className="p-4 md:p-6 lg:p-8 pt-16 lg:pt-8" data-id="element-57">
          <Outlet data-id="element-58" />
        </div>
      </main>
    </div>;
}